import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

export function start(
  element: HTMLElement,
  baseUrl: string | undefined = '',
  headerText = 'Alle er velkomne.',
  searchHeaderText = 'Alle er velkomne.',
  branchOverviewHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h2',
  branchHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h1',
  employeeHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h1',
  employeeBranchHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h2',
  showMobile = true,
  showFax = true,
  notFoundPage?: string
) {
  const finalBase = baseUrl
    ? baseUrl
    : process.env.REACT_APP_ENV === 'D'
    ? '/wco/rc/widget-fmi/' + process.env.REACT_APP_BANK
    : process.env.REACT_APP_ENV === 'P'
    ? '/wco/release/widget-fmi/' + process.env.REACT_APP_BANK
    : undefined;
  ReactDOM.render(
    <App
      baseUrl={finalBase}
      headerText={headerText}
      showMobile={showMobile}
      branchOverviewHeadlineSize={branchOverviewHeadlineSize}
      branchHeadlineSize={branchHeadlineSize}
      employeeHeadlineSize={employeeHeadlineSize}
      employeeBranchHeadlineSize={employeeBranchHeadlineSize}
      searchHeaderText={searchHeaderText}
      showFax={showFax}
      notFoundPage={notFoundPage}
    />,
    element
  );
}

export function stop(element: HTMLElement) {
  if (element) {
    ReactDOM.unmountComponentAtNode(element);
  }
}

export { default as App } from './App';
